import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass([_ctx.clazz, "btn btn-sm btn-icon btn-color-primary btn-active-primary"]),
      style: _normalizeStyle(_ctx.style),
      "data-kt-menu-trigger": "click",
      "data-kt-menu-placement": "bottom-end",
      "data-kt-menu-flip": "top-end"
    }, _hoisted_2, 6),
    _createElementVNode("div", {
      class: _normalizeClass(["menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold fs-7 py-4", _ctx.size]),
      "data-kt-menu": "true"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 64))
}